export const mainContainerStyle = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  padding: '0.5rem 1rem',
  'font-family': "'Noto Sans JP', sans-serif",
}
